import { Component, OnInit, Input } from '@angular/core';
import { ProfileService, ClientsService } from 'core/services';

@Component({
  selector: 'lms-no-itineraries',
  templateUrl: './no-itineraries.component.html',
  styleUrls: ['./no-itineraries.component.scss']
})
export class NoItinerariesComponent implements OnInit {
  @Input() isCreator: boolean;
  @Input() clientView: boolean;
  public isCorporateWithSubscriptionClient: boolean = true;

  constructor(public profileService: ProfileService, public clientsService: ClientsService) {}

  ngOnInit() {
    this.profileService.getLoggedUser$().subscribe((loggedUser) => {
      if (loggedUser.roleOptions.scope === 'client') {
        this.clientsService.getClient(loggedUser.selectedClientId).subscribe((client) => {
          this.isCorporateWithSubscriptionClient = client?.subscriptions?.users;
        });
      }
    });
  }
}
